import React, { createContext, useCallback, useMemo, useState } from 'react';

export type PanelContextValue = {
	isOpen: boolean;
	togglePanel: () => void;
};

export const PanelContext: React.Context<PanelContextValue | undefined> = createContext<
	PanelContextValue | undefined
>(undefined);

type PanelProviderProps = {
	children: React.ReactNode;
};

export function PanelProvider({ children }: PanelProviderProps): React.JSX.Element {
	const [isOpen, setIsOpen] = useState(false);

	const togglePanel = useCallback(() => {
		setIsOpen((_) => !_);
	}, []);

	const value = useMemo(
		() => ({
			isOpen,
			togglePanel,
		}),
		[isOpen, togglePanel],
	);

	return <PanelContext.Provider value={value}>{children}</PanelContext.Provider>;
}
